import { Divider, Group, ScrollArea, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Outcome } from '../../../../../api/strategy-client';
import { useTranslation } from 'react-i18next';
import { SmallSquareButton } from '../../../../../components/small-square-button/small-square-button';
import { useMilestonesTabStore, useStrategyStore } from '../../../../../store/strategy-store/strategy-store';
import { setSelectedMilestone } from '../../../../../store/strategy-store/strategy-store.actions';
import { baseWhite } from '../../../../../styles/design-tokens';
import { Button } from '../../../../../ui-library/button/button';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';
import { MilestoneModal } from '../modal/milestone-modal';
import { MilestoneItem } from './milestone-item';

type Props = {
  setShow: (show: boolean) => void;
};

export const Filters = ({ setShow }: Props) => {
  const i18n = useTranslation();
  const milestones = useMilestonesTabStore((state) => state.milestones);
  const selectedMilestone = useMilestonesTabStore((state) => state.selectedMilestone);
  const initiativePerformance = useStrategyStore((state) => state.initiativePerformance);
  const [isMilestoneModalOpen, setIsMilestoneModalOpen] = useState(false);
  const [milestoneModalMode, setMilestoneModalMode] = useState<'create' | 'edit'>('create');

  useEffect(() => {
    if (!selectedMilestone && milestones.length > 0) {
      setSelectedMilestone(milestones[0]);
    }
  }, [selectedMilestone, milestones]);

  return (
    <Stack gap="md" h="100%">
      <Group justify="space-between" align="center">
        <Text size="medium" weight="bold">
          {i18n.t('strategy.initiative_performance.milestones')}
        </Text>
        <Group gap={16}>
          <Button
            size="xs"
            radius="xl"
            variant="primary"
            leftSection={<Icon name="add_circle_outline" color={baseWhite} size={16} pointer />}
            onClick={() => {
              setMilestoneModalMode('create');
              setIsMilestoneModalOpen(true);
            }}
          >
            Create
          </Button>
          <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
        </Group>
      </Group>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <Stack gap="sm">
          {milestones.map((milestone) => (
            <MilestoneItem
              key={milestone.id}
              milestone={milestone}
              setMilestoneModalMode={setMilestoneModalMode}
              setIsMilestoneModalOpen={setIsMilestoneModalOpen}
            />
          ))}
        </Stack>
      </ScrollArea>

      <MilestoneModal
        mode={milestoneModalMode}
        milestone={milestoneModalMode === 'edit' ? selectedMilestone || undefined : undefined}
        outcome={initiativePerformance as any as Outcome}
        opened={isMilestoneModalOpen}
        onClose={() => setIsMilestoneModalOpen(false)}
      />
    </Stack>
  );
};
